module.exports = __webpack_public_path__ + "static/media/logo_mxl.3fb09673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_mxl.png
// module id = 516
// module chunks = 0